"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlarms = exports.Alarm = exports.decodeAlarm = exports.AlarmEventState = void 0;

var uuid_1 = require("./support/uuid");

var alert_1 = require("./alert");

var alarm_1 = require("./http/alarm");

var AlarmEventState;

(function (AlarmEventState) {
  AlarmEventState[AlarmEventState["Clear"] = 0] = "Clear";
  AlarmEventState[AlarmEventState["Alarm"] = 1] = "Alarm";
})(AlarmEventState = exports.AlarmEventState || (exports.AlarmEventState = {}));

;

function decodeAlarm(a) {
  var uuid = uuid_1.EmptyUUID();
  var assetID = "";

  if (a.uuid && a.uuid.length > 20) {
    uuid = new uuid_1.UUID(a.uuid);
  }

  if (a.deviceUUID && a.deviceUUID.length > 20) {
    uuid = new uuid_1.UUID(a.deviceUUID);
  }

  if (a.assetID) {
    assetID = a.assetID;
  }

  var start = new Date(a.start);
  var stop = new Date(a.stop);
  return new Alarm(a.id, uuid, assetID, start, stop, a.severity, a.message, a.domain, a.subdomain, a.action);
}

exports.decodeAlarm = decodeAlarm;
/** Alarms are stateful alarms for a given unit */

var Alarm =
/** @class */
function () {
  function Alarm(id, uuid, assetID, start, stop, severity, message, domain, subdomain, action) {
    if (message === void 0) {
      message = "";
    }

    if (domain === void 0) {
      domain = alert_1.AlertDomain.NotApplicable;
    }

    if (subdomain === void 0) {
      subdomain = alert_1.AlertSubdomain.NotApplicable;
    }

    if (action === void 0) {
      action = alert_1.AlertAction.NotApplicable;
    }

    this.id = id;
    this.uuid = uuid;
    this.assetID = assetID;
    this.start = start;
    this.stop = stop;
    this.severity = severity;
    this.message = message;
    this.domain = domain;
    this.subdomain = subdomain;
    this.action = action;
  }

  ;

  Alarm.prototype.ongoing = function () {
    return Date.now() <= this.stop.getTime();
  };

  Alarm.prototype.get = function (credentials) {
    var _this = this;

    return alarm_1.getAlarm(this.id, credentials).then(function (ret) {
      if (ret === undefined) {
        return _this;
      }

      _this.uuid = new uuid_1.UUID(ret.deviceUUID);
      _this.start = new Date(ret.start);
      _this.stop = new Date(ret.stop);
      _this.severity = ret.severity;
      _this.message = ret.message;
      _this.domain = ret.domain;
      _this.subdomain = ret.subdomain;
      _this.action = ret.action;
      return _this;
    });
  };

  Alarm.prototype.getEvents = function (credentials) {
    return alarm_1.getEvents(this.id, credentials).then(function (ret) {
      if (ret == null) {
        return [];
      }

      return ret.map(function (r) {
        return {
          id: r.id,
          time: new Date(r.time),
          state: r.state,
          message: r.message,
          value: r.value
        };
      });
    });
  };

  return Alarm;
}();

exports.Alarm = Alarm;
;

function getAlarms(time, credentials) {
  return alarm_1.get(time, credentials).then(function (ret) {
    if (ret == null || ret.length === 0) {
      return [];
    }

    return ret.map(function (r) {
      return decodeAlarm(r);
    });
  });
}

exports.getAlarms = getAlarms;